import {Component, OnInit, ChangeDetectionStrategy, Input, Inject} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {IdynamicFormItem} from "@ispm/dynamic-form/interfaces/IdynamicFormItem";
import {EventValidationWizardService} from "@ispm-client/modules/events/services/event-validation-wizard.service";
import {EventService} from "@ispm-client/modules/events/services/event.service";
import {IEvent, IEventDefinition, IEventManagerConfig, IEventMapParam} from "@ispm-client/modules/events/Interfaces";
import {INLPHighlightConfig} from "@ispm-client/modules/file-module/Interfaces";
import {Widget} from "@ispm/widgets/decorator/widget.decorator";
import {ConfirmModalLoaderPayload} from "@ispm/layout/classes/confirm-modal-loader-payload";
import {ModalLoaderNgjsService} from "@ispm/layout/services/modal-loader-ngjs.service";
import {TranslateService} from "@ngx-translate/core";
import {modalResponse} from "@ispm/layout/constants/modal-responses.enum";
import {findIndex, get, set, has, cloneDeep, isEqual} from 'lodash';
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

@Component({
  selector: 'ispm-nlp-validation-wizard',
  templateUrl: './nlp-validation-wizard.component.html',
  styleUrls: ['./nlp-validation-wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('NLPValidationWizard')
export class NLPValidationWizardComponent implements OnInit {
  @Input() selectedEvent: IEvent;
  @Input() eventsDefinitions: Map<string, IEventDefinition>;
  @Input() config: IEventManagerConfig;
  @Input() reviewExtractionKey: boolean = false;
  eventDefinition: IEventDefinition;
  public payload: any;
  public widgetPayload: any;
  public formId: any;
  public data: any;
  public actionItems: any;
  @Input() public findingsData: any;
  currentFinding = 0;
  fileViewerFinding: number;
  public displayCurrentFinding: number = this.currentFinding + 1;
  public totalReviewData: number;
  private filterExpression: any;
  public wizardLabel: string;
  public headerConfig: any;
  public reviewData: any;
  showDataCaptureSection: boolean = true;
  nlpConfiguration: INLPHighlightConfig;
  addReportAvailable: boolean = true;
  eventFileIdList: Array<string>;
  deleted: number = 0;
  private findingFileMap = new Map<string, number>();
  public perFindingUpdatedData: any;
  public isDataUpdated: boolean = false;
  fileScroll: any;
  findingDataArr: Array<any> = [];
  private eventFormKeyMap = new Map();
  private eventMapParam: IEventMapParam = {
    eventBasedOnDataChange: false
  }
  private reviewExtraction: string;
  private componentDestroyer: Subject<any> = new Subject();

  @Input()
  set _selectedEvent(event) {
    if (!event) {
      this.selectedEvent = event;


    }
  }


  constructor(private _eventService: EventService,
              private _modalLoaderService: ModalLoaderNgjsService, private _translate: TranslateService,
              private eventWizardService: EventValidationWizardService,
              private notificationMessageService: NotificationMessageService,
              private notificationMessage: NOTIFICATION_MESSAGE) {
    this.currentFinding = 0;
  }


  ngOnInit() {
    const eventCategory = get(this.selectedEvent, 'category.code');
    this.reviewExtraction = this.eventWizardService.getReviewExtractionKey();
    this._eventService.getEventDefinition(eventCategory).subscribe(resp => {
      const reviewExtractionConfig = get(resp, `common.reviewExtractionConfig.${this.reviewExtraction}`);
      if (reviewExtractionConfig) {
        this.formId = reviewExtractionConfig.formId;
        this.actionItems = reviewExtractionConfig.actions;
        this.filterExpression = reviewExtractionConfig.filterExpression;
        this.wizardLabel = reviewExtractionConfig.header.label;
        this.headerConfig = reviewExtractionConfig.header;
      }

      this.prepareEventDefinition();
      this.filterData(this.selectedEvent.content, this.reviewExtraction);
      this.prepareEventFileList(this.selectedEvent.content);
      this.isDataUpdated = false;
    });
    this.isDataUpdated = false;
  }

  prepareEventFileList(content: Array<any>) {
    const refObj = {};
    content.forEach((e) => {
      (refObj[e.contentType] ? refObj[e.contentType].push(e) : (refObj[e.contentType] = [e]));
    });
    this.eventFileIdList = refObj['file'];
  }

  prepareEventDefinition() {
    let saveButtonExclusionFields: Array<string> = [];
    if (this.eventsDefinitions && this.selectedEvent) {
      this.eventDefinition = this.eventsDefinitions.get(this.selectedEvent.category.code);
    }
    if (has(this.eventDefinition, ["ui", "enableSaveButtonBasedOnDataChange", "exclusionFields"])) {
      saveButtonExclusionFields = get(this.eventDefinition, ["ui", "enableSaveButtonBasedOnDataChange", "exclusionFields"]);
    }

    this.eventMapParam = {
      eventBasedOnDataChange: true,
      exclusionKeys: saveButtonExclusionFields
    }
  }

  set widgetData(widgetData: any) {
    this.data = this.selectedEvent;

  }

  set widgetConfig(widgetConfig: IdynamicFormItem) {
    if (!widgetConfig) {
      this.formId = widgetConfig.widgetPayload.formId;
      this.widgetPayload = widgetConfig.widgetPayload;
      this.actionItems = widgetConfig.widgetPayload.actions;
      this.filterExpression = widgetConfig.widgetPayload.filterExpression;
      this.wizardLabel = widgetConfig.widgetPayload.header.label;
      this.headerConfig = widgetConfig.widgetPayload.header;
    }
  }

  private filterData(content: any, extractionKey: string) {

    if (content && Array.isArray(content)) {
      this.reviewData = content.filter(item => item.formKey === extractionKey);
      if (this.reviewData) {
        this.findingsData = this.reviewData[this.currentFinding].data;
        this.totalReviewData = this.reviewData.length;
        this.createMapping();
        let lesionId = this.reviewData[this.currentFinding].data.lesionID;
        this.fileViewerFinding = this.getFileEventIndex(lesionId);
        this.findingDataArr.push(this.fileViewerFinding);
        this.findingDataArr.push(lesionId);

      }

    }
    this.eventFormKeyMap = this._eventService.selectedEventMap(this.eventMapParam, cloneDeep(this.selectedEvent));
  }

  performAction(action: any) {
    switch (action.type) {
      case "next":
        this.loadNextFinding();
        break;
      case "close":
        this.closeWizard();
        break;
      case "delete":
        this.deleteFinding();
        break;
      case "confirm":
        this.confirmExtraction();
        break;
    }
  }


  private closeWizard() {
    if (this.isDataUpdated) {
      this._modalLoaderService.popupModal('confirm',
        ConfirmModalLoaderPayload.builder()
          .setTitle(this._translate.instant('DISCARD_DATA') || 'Discard Data')
          .setContent(this._translate.instant('UN_SAVED_CHANGES') || 'Unsaved changes have been made to current event. Would you like to continue (changes will not be saved)?.')
          .setDeclineButtonText('Discard Changes')
          .setApproveButtonText(this._translate.instant('SAVE') || 'Save'),
        'ALERT').subscribe(response => {
        if (get(response, 'payload') === modalResponse.approve) {
          this.saveCurrentData();
          this._eventService.clearViewWizard();
        } else {
          this.isDataUpdated = false;
          this._eventService.clearViewWizard();
        }
      });
    } else {
      this._eventService.clearViewWizard();
    }

  }

  private deleteFinding() {
    this.findingDataArr = [];
    this.findingDataArr.push(this.fileViewerFinding);
    this._modalLoaderService.popupModal('confirm',
      ConfirmModalLoaderPayload.builder()
        .setTitle(this._translate.instant('DELETE_FINDING') || 'Delete Finding')
        .setContent(this._translate.instant('DELETE_FINDING_TEXT') || 'Are you sure you want to delete this finding?')
        .setApproveButtonText('Confirm')
        .setDeclineButtonText('Cancel'),
      'ALERT'
    ).subscribe((response: modalResponse) => {
      if (get(response, 'payload') === modalResponse.approve) {
        this.reviewData.splice(this.currentFinding, 1);
        if (this.currentFinding < this.totalReviewData - 1) {
          this.findingDataArr = [];
          this.findingsData = this.reviewData[this.currentFinding].data;
          this.displayCurrentFinding = this.currentFinding + 1;
          let lesionId = this.reviewData[this.currentFinding].data.lesionID;
          this.fileViewerFinding = this.getFileEventIndex(lesionId);
          this.findingDataArr.push(this.fileViewerFinding);
          this.findingDataArr.push(lesionId);
        }


        if (this.totalReviewData === 1) {
          this.findingDataArr = [];
          this.currentFinding--;
          this.notificationMessageService.info(this.notificationMessage.NO_FINDINGS_INFO);
          this.saveDeletedData();
          this.closeWizard();

        }
        if (this.currentFinding === this.totalReviewData - 1) {
          this.findingDataArr = [];
          this.currentFinding--;
          this.findingsData = this.reviewData[this.currentFinding].data;
          this.displayCurrentFinding = this.currentFinding + 1;
          let lesionId = this.reviewData[this.currentFinding].data.lesionID;
          this.fileViewerFinding = this.getFileEventIndex(lesionId);
          this.findingDataArr.push(this.fileViewerFinding);
          this.findingDataArr.push(lesionId);
        }
        this.saveDeletedData();
        --this.totalReviewData;
      }
    });
  }

  private loadNextFinding() {
    this.findingDataArr = [];
    if (this.currentFinding < this.totalReviewData - 1) {
      this.currentFinding++;
      this.findingsData = this.reviewData[this.currentFinding].data;
      this.displayCurrentFinding = this.currentFinding + 1;
      let lesionId = this.reviewData[this.currentFinding].data.lesionID;
      this.fileViewerFinding = this.getFileEventIndex(lesionId);
      this.findingDataArr.push(this.fileViewerFinding);
      this.findingDataArr.push(lesionId);
    }
  }

  loadPreviousFinding() {
    this.findingDataArr = [];
    if (this.currentFinding > 0) {
      --this.currentFinding;
      this.findingsData = this.reviewData[this.currentFinding].data;
      this.displayCurrentFinding = this.currentFinding + 1;
      let lesionId = this.reviewData[this.currentFinding].data.lesionID;
      this.fileViewerFinding = this.getFileEventIndex(lesionId);
      this.findingDataArr.push(this.fileViewerFinding);
      this.findingDataArr.push(lesionId);
    }
  }


  private confirmExtraction() {
    if (this.isDataUpdated) {
      this.saveCurrentData();
    }
    if (!get(this.selectedEvent, 'approved')) {
      set(this.selectedEvent, 'approved', true);
      this._eventService.updateEvent(this.selectedEvent.id, this.selectedEvent).subscribe(data => {
        this.notificationMessageService.success(this.notificationMessage.EVENT_APPROVED_SUCCESSFULLY);
      });
    }
    this._eventService.clearViewWizard();
  }

  private createMapping() {
    let nlpHighlights = this.eventWizardService.getNLPHighlights();
    let events = nlpHighlights.events;
    // let findingIndex: number = this.currentFinding;
    this.reviewData.forEach(item => {
      const eventIndex = findIndex(events, function (eventItem: any) {
        if (eventItem.attributes.hasOwnProperty('Specimen id')) {
          return eventItem.attributes['Specimen id']['value'] === item.data.lesionID;
        }
      });
      let eventIndex2;
      if (eventIndex === -1) {
        eventIndex2 = findIndex(events, function (eventItem: any) {
          if (eventItem.attributes.hasOwnProperty('Specimen label')) {
            return eventItem.attributes['Specimen label']['value'] === item.data.lesionID;
          }
        })
      }
      this.findingFileMap.set(item.data.lesionID, eventIndex === -1 ? eventIndex2 : eventIndex);
    })


  }

  private getFileEventIndex(id): number {
    return this.findingFileMap.get(id);
  }

  private saveDeletedData() {
    let content = get(this.selectedEvent, 'content');
    let contentData = content.filter(item => item.formKey !== this.reviewExtraction);
    let updatedData = [...contentData, ...this.reviewData];
    set(this.selectedEvent, 'content', updatedData);
    this._eventService.updateEvent(this.selectedEvent.id, this.selectedEvent).subscribe(data => {
      this.selectedEvent = data;
    })

  }


  getPerFindingDataUpdate(newEventData: any) {
    delete newEventData['modified']
    delete newEventData['key']
    delete newEventData['formId']
    this.perFindingUpdatedData = newEventData
    this.dataModificationCheck();

  }

  saveAndLoadNextFinding() {
    this.saveCurrentData();
    this.loadNextFinding();
  }

  saveCurrentData() {
    if (this.isDataUpdated) {
      let content = get(this.selectedEvent, 'content');
      let contentData = content.filter(item => item.formKey !== 'pathologyFindings');
      let selectedFindingData = content.filter(item => item.formKey === 'pathologyFindings');
      let currentData = this.reviewData[this.currentFinding];
      currentData['data'] = this.perFindingUpdatedData

      for (let i = 0; i < selectedFindingData.length; i++) {
        if (selectedFindingData[i]['data']['index'] == currentData['data']['index']) {
          selectedFindingData[i]['data'] = currentData['data'];
          break;
        }
      }
      for (let i = 0; i < selectedFindingData.length; i++) {
        if (selectedFindingData[i]['data']['index'] == currentData['data']['index']) {
          selectedFindingData[i]['data'] = currentData['data'];
          break;
        }
      }
      let updatedData = [...contentData, ...selectedFindingData];
      set(this.selectedEvent, 'content', updatedData);
      this._eventService.updateEvent(this.selectedEvent.id, this.selectedEvent).subscribe(data => {
        this.selectedEvent = data;
      });
    }
    this.isDataUpdated = false;
  }


  private dataModificationCheck() {
    //TODO  compare 2 simple object, 1 array with exclusion -- function inside aggregator service -- utility function
    const currentEventData = cloneDeep(this.perFindingUpdatedData);
    delete currentEventData['modified'];
    const firstKey = this.reviewExtraction;
    const findingsEventFormData = this.eventFormKeyMap.get(firstKey);
    const currentFindingEventFormData = findingsEventFormData.filter(item => item.lesionID === currentEventData.lesionID);
    const eventFormData = currentFindingEventFormData[0];
    if (currentEventData !== undefined) {
      if (Array.isArray(currentEventData)) {
        this._eventService.deleteBlankNullValuesForArrays(currentEventData,
          this.eventMapParam.exclusionKeys);
      } else {
        this._eventService.deleteBlankNullValues(currentEventData,
          this.eventMapParam.exclusionKeys);
      }
    }
    //TODO current nesting depth is 1, if required need to change for further nesting levels
    const dataIsEqual: boolean = isEqual(currentEventData, eventFormData);
    if (!dataIsEqual) {
      this.isDataUpdated = true;
    }
  }

  ngOnDestroy(): void {
    this.componentDestroyer.next();
    this.componentDestroyer.complete();
  }


}
